import { render, staticRenderFns } from "./FuelStationDetailsContainer.vue?vue&type=template&id=22ea1c4b"
import script from "./FuelStationDetailsContainer.vue?vue&type=script&lang=js"
export * from "./FuelStationDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports